// PHIN — theme JS. Cart drawer + AJAX add-to-cart + quiz + small UI niceties.
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  // ---------- Cart drawer ----------
  const drawer = $('#CartDrawer');
  const drawerBody = $('#CartDrawerBody');
  const drawerOverlay = $('.cart-drawer-overlay');
  const cartCount = $$('.cart-count');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      // Always show a number — the label renders as "Cart (n)", so hiding the
      // span would leave an empty pair of parentheses.
      cartCount.forEach(el => { el.textContent = cart.item_count; });
      if (drawerBody) await renderDrawer(cart);
    } catch (e) { console.error('[phin] cart refresh failed', e); }
  }

  async function renderDrawer(cart) {
    try {
      const res = await fetch('/?sections=cart-drawer');
      const data = await res.json();
      const html = data['cart-drawer'];
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      // The Section Rendering API returns the cart-drawer section wrapped in
      // #shopify-section-cart-drawer, which contains cart-drawer-contents only —
      // there is no #CartDrawerBody inside it. Unwrap whichever we actually get.
      const fresh = tmp.querySelector('#CartDrawerBody')
                 || tmp.querySelector('[id^="shopify-section-"]')
                 || tmp;
      if (drawerBody) drawerBody.innerHTML = fresh.innerHTML;
    } catch (e) { console.error('[phin] drawer render failed', e); }
  }

  async function addToCart(form) {
    const submit = form.querySelector('[type=submit]');
    if (submit) { submit.disabled = true; submit.dataset.origText = submit.textContent; submit.textContent = 'Adding…'; }
    try {
      const body = new FormData(form);
      body.set('sections', 'cart-drawer');
      const res = await fetch('/cart/add.js', { method: 'POST', body, headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('add failed');
      await refreshCart();
      openDrawer();
    } catch (e) {
      console.error('[phin] add to cart failed', e);
      alert('Sorry, we couldn’t add that to your cart.');
    } finally {
      if (submit) { submit.disabled = false; submit.textContent = submit.dataset.origText || 'Add to cart'; }
    }
  }

  async function updateItem(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!res.ok) throw new Error('update failed');
      await refreshCart();
    } catch (e) { console.error('[phin] cart update failed', e); }
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-cart-toggle]');
    if (openBtn) { e.preventDefault(); openDrawer(); return; }

    const closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn || e.target === drawerOverlay) { e.preventDefault(); closeDrawer(); return; }

    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) { e.preventDefault(); updateItem(removeBtn.dataset.cartRemove, 0); return; }

    const incBtn = e.target.closest('[data-cart-inc]');
    if (incBtn) { e.preventDefault(); updateItem(incBtn.dataset.cartInc, parseInt(incBtn.dataset.nextQty, 10)); return; }

    const decBtn = e.target.closest('[data-cart-dec]');
    if (decBtn) { e.preventDefault(); updateItem(decBtn.dataset.cartDec, parseInt(decBtn.dataset.nextQty, 10)); return; }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (form) { e.preventDefault(); addToCart(form); }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Refresh count on load
  refreshCart();

  // ---------- Mobile nav ----------
  const navToggle = $('[data-nav-toggle]');
  const mobileNav = $('#MobileNav');

  function closeNav() {
    if (!mobileNav || !navToggle) return;
    mobileNav.hidden = true;
    navToggle.setAttribute('aria-expanded', 'false');
    navToggle.classList.remove('is-open');
  }

  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', () => {
      const open = mobileNav.hidden;
      mobileNav.hidden = !open;
      navToggle.setAttribute('aria-expanded', String(open));
      navToggle.classList.toggle('is-open', open);
    });
    // Close when a link is followed, when the cart opens, or on resize to desktop
    mobileNav.addEventListener('click', (e) => { if (e.target.closest('a')) closeNav(); });
    window.addEventListener('resize', () => { if (window.innerWidth > 900) closeNav(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeNav(); });
  }

  // ---------- Quiz ----------
  const quiz = $('[data-ritual-quiz]');
  if (quiz) {
    const steps = $$('[data-quiz-step]', quiz);
    const result = $('[data-quiz-result]', quiz);
    const progress = $('[data-quiz-progress]', quiz);
    const dots = progress ? $$('.progress-dot', progress) : [];
    const lines = progress ? $$('.progress-line', progress) : [];
    const answers = {};

    // Mark dots up to `index` as done and `index` itself as current.
    function setProgress(index) {
      dots.forEach((dot, i) => {
        dot.classList.toggle('done', i < index);
        dot.classList.toggle('active', i === index);
      });
      lines.forEach((line, i) => line.classList.toggle('done', i < index));
    }

    $$('[data-quiz-opt]', quiz).forEach(opt => {
      opt.addEventListener('click', () => {
        const step = opt.closest('[data-quiz-step]');
        const key = step.dataset.quizStep;
        answers[key] = opt.dataset.quizOpt;
        const next = step.nextElementSibling;
        step.classList.remove('is-active');
        if (next && next.matches('[data-quiz-step]')) {
          next.classList.add('is-active');
          setProgress(steps.indexOf(next));
        } else if (result) {
          // Tally: map answer counts to ritual
          const ritual = pickRitual(answers);
          result.dataset.ritualResult = ritual;
          result.classList.add('is-active');
          setProgress(steps.length);
        }
      });
    });

    function pickRitual(a) {
      // Simple scoring: each answer suggests a ritual
      const score = { coffee: 0, matcha: 0, oolong: 0 };
      Object.values(a).forEach(v => { if (score[v] != null) score[v]++; });
      return Object.entries(score).sort((a, b) => b[1] - a[1])[0][0];
    }
  }

  // ---------- Product gallery ----------
  // The thumbnails had a pointer cursor and a hover state but no handler, so
  // clicking one did nothing. Not motion or decoration — this is core product
  // browsing, so it is deliberately outside the reduced-motion gate below.
  const galleryMain = $('[data-gallery-main]');
  const galleryFrame = $('[data-gallery-frame]');
  const thumbs = $$('[data-gallery-thumb]');

  if (galleryMain && thumbs.length) {
    const show = (btn) => {
      const d = btn.dataset;
      if (!d.full || galleryMain.getAttribute('src') === d.full) return;
      galleryMain.setAttribute('src', d.full);
      if (d.srcset) galleryMain.setAttribute('srcset', d.srcset);
      if (d.alt) galleryMain.setAttribute('alt', d.alt);
      if (d.w) galleryMain.setAttribute('width', d.w);
      if (d.h) galleryMain.setAttribute('height', d.h);
      // The frame is sized to the photograph, so it has to follow the swap —
      // otherwise a differently-shaped image letterboxes inside the old ratio.
      if (galleryFrame && d.ratio) galleryFrame.style.aspectRatio = d.ratio;

      thumbs.forEach(t => {
        const on = t === btn;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };

    thumbs.forEach(btn => btn.addEventListener('click', () => show(btn)));
  }

  // ---------- Marquee duplicator (if any) ----------
  $$('[data-marquee]').forEach(el => {
    el.innerHTML += el.innerHTML;
  });

  // ==========================================================================
  // Motion
  //
  // All of it is additive: every effect below is applied by JS to markup that
  // is already complete and readable, so no-JS and reduced-motion visitors lose
  // decoration and nothing else.
  // ==========================================================================
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // ---------- The Brew: scroll progress as a phin filling a glass ----------
  const brew = $('[data-brew]');
  if (brew && !reduceMotion.matches) {
    const fill = $('[data-brew-fill]', brew);
    const crema = $('[data-brew-crema]', brew);
    const foam = $('[data-brew-crema-group]', brew);
    // Each vessel declares its own interior range in its own SVG coordinates —
    // the phin glass, the matcha bowl and the gaiwan are all different shapes,
    // so this must not be hardcoded to any one of them.
    const TOP = parseFloat(fill.dataset.fillTop) || 36.4;
    const BOTTOM = parseFloat(fill.dataset.fillBottom) || 60.6;
    const RANGE = BOTTOM - TOP;

    let dripTimer = null;
    let queued = false;
    let lastLight = null;

    // Geometry properties animate only when set as CSS; the attribute is the
    // fallback for engines that do not expose them that way.
    // Null-safe: not every vessel has a surface line. The matcha bowl uses a
    // foam group instead, and calling this with null would throw and take the
    // whole indicator down.
    function setY(el, value) {
      if (!el) return;
      el.style.y = value + 'px';
      el.setAttribute('y', value);
    }

    // Is the surface behind the widget light? Sampled rather than assumed,
    // because section backgrounds are merchant-controlled.
    function surfaceIsLight() {
      const box = brew.getBoundingClientRect();
      const x = Math.round(box.left - 24);
      const y = Math.round(box.top + box.height / 2);
      if (x < 0 || y < 0 || y > window.innerHeight) return null;
      const stack = document.elementsFromPoint(x, y) || [];
      for (const el of stack) {
        if (brew.contains(el)) continue;
        const bg = getComputedStyle(el).backgroundColor;
        const m = bg.match(/rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?\)/);
        if (!m) continue;
        if (m[4] !== undefined && parseFloat(m[4]) < 0.5) continue; // see-through
        const [r, g, b] = [+m[1], +m[2], +m[3]];
        return (0.2126 * r + 0.7152 * g + 0.0722 * b) > 140;
      }
      return null;
    }

    function update() {
      queued = false;
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - window.innerHeight;
      const progress = scrollable > 0 ? Math.min(1, Math.max(0, window.scrollY / scrollable)) : 0;

      const y = BOTTOM - progress * RANGE;
      setY(fill, y);
      setY(crema, y);
      if (foam) {
        // Foam rides the surface, and only reads once there is tea beneath it.
        foam.setAttribute('transform', 'translate(0 ' + y.toFixed(2) + ')');
        foam.style.opacity = progress > 0.12 ? '1' : '0';
      }

      brew.classList.toggle('is-full', progress > 0.995);
      brew.classList.toggle('is-ready', window.scrollY > 120);

      const light = surfaceIsLight();
      if (light !== null && light !== lastLight) {
        lastLight = light;
        brew.classList.toggle('on-light', light);
      }

      // Drip while the page is moving, stop shortly after it settles.
      brew.classList.add('is-dripping');
      clearTimeout(dripTimer);
      dripTimer = setTimeout(() => brew.classList.remove('is-dripping'), 420);
    }

    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }

    brew.hidden = false;
    update();
    brew.classList.remove('is-dripping');
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    brew.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // ---------- The Bloom: pointer-origin bloom on ritual cards ----------
  const ritualCards = document.body.hasAttribute('data-motion-bloom') ? $$('.ritual-card') : [];
  if (ritualCards.length && !reduceMotion.matches && window.matchMedia('(hover: hover)').matches) {
    ritualCards.forEach(card => {
      const bloom = document.createElement('span');
      bloom.className = 'bloom';
      bloom.setAttribute('aria-hidden', 'true');
      card.appendChild(bloom);

      card.addEventListener('pointermove', (e) => {
        const box = card.getBoundingClientRect();
        card.style.setProperty('--mx', ((e.clientX - box.left) / box.width * 100).toFixed(1) + '%');
        card.style.setProperty('--my', ((e.clientY - box.top) / box.height * 100).toFixed(1) + '%');
      }, { passive: true });
    });
  }

  // ---------- Pour reveal: headings wipe in the first time they are seen ----
  // The hero is deliberately excluded — the first thing a visitor reads should
  // never be waiting on an animation.
  const pourable = document.body.hasAttribute('data-motion-pour')
    ? $$('.section-title, .story-head, .email-head, .quiz-title')
    : [];
  if (pourable.length && !reduceMotion.matches && 'IntersectionObserver' in window) {
    // Observe the PARENT, never the heading itself. `clip-path` collapses an
    // element's intersection rect to zero, so a clipped heading is permanently
    // invisible to IntersectionObserver — it would hide itself and then wait
    // forever for a callback that can never fire.
    const pairs = pourable.map(el => ({ el: el, watch: el.parentElement || el }));
    pourable.forEach(el => el.classList.add('pour'));

    const pour = (el) => el.classList.add('is-poured');

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        pairs.filter(p => p.watch === entry.target).forEach(p => pour(p.el));
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.1 });

    pairs.forEach(p => io.observe(p.watch));

    // Anything already on screen at load pours immediately rather than waiting.
    requestAnimationFrame(() => {
      pairs.forEach(p => {
        if (p.watch.getBoundingClientRect().top < window.innerHeight) pour(p.el);
      });
    });

    // Failsafe. A heading being decorative is fine; a heading being invisible is
    // not. If anything above goes wrong, everything is shown regardless.
    setTimeout(() => pourable.forEach(pour), 4000);
  }

})();

/* ---------------------------------------------------------------------------
   Customer address forms
   Two jobs: fill the province select from the chosen country, and confirm
   before an address is deleted. Shopify ships country_option_tags with a
   data-provinces JSON array on each <option>; a country with no provinces
   gets its field hidden rather than left as an empty dropdown.
   ------------------------------------------------------------------------ */
(function () {
  var countries = document.querySelectorAll('[data-address-country]');
  if (!countries.length) return;

  function syncProvinces(countrySelect) {
    var form = countrySelect.closest('form');
    if (!form) return;
    var province = form.querySelector('[data-address-province]');
    var wrap = form.querySelector('[data-address-province-wrap]');
    if (!province || !wrap) return;

    var opt = countrySelect.options[countrySelect.selectedIndex];
    var list = [];
    try { list = JSON.parse(opt.getAttribute('data-provinces') || '[]'); } catch (e) { list = []; }

    if (!list.length) {
      wrap.hidden = true;
      province.innerHTML = '';
      return;
    }

    wrap.hidden = false;
    var want = province.getAttribute('data-default') || '';
    province.innerHTML = '';
    list.forEach(function (pair) {
      var o = document.createElement('option');
      o.value = pair[0];
      o.textContent = pair[1];
      if (pair[0] === want) o.selected = true;
      province.appendChild(o);
    });
  }

  countries.forEach(function (select) {
    var want = select.getAttribute('data-default');
    if (want) {
      // Re-select the saved country before filling provinces, so an edit form
      // opens showing what the customer actually saved.
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].value === want) { select.selectedIndex = i; break; }
      }
    }
    syncProvinces(select);
    select.addEventListener('change', function () {
      select.setAttribute('data-default', '');
      var form = select.closest('form');
      var province = form && form.querySelector('[data-address-province]');
      if (province) province.setAttribute('data-default', '');
      syncProvinces(select);
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-address-delete]');
    if (!btn) return;
    e.preventDefault();
    var msg = btn.getAttribute('data-confirm-message') || 'Delete this address?';
    if (!window.confirm(msg)) return;

    // Shopify deletes an address by POSTing _method=delete to the address URL.
    var form = document.createElement('form');
    form.method = 'post';
    form.action = btn.getAttribute('data-target');
    form.style.display = 'none';
    var m = document.createElement('input');
    m.type = 'hidden'; m.name = '_method'; m.value = 'delete';
    form.appendChild(m);
    document.body.appendChild(form);
    form.submit();
  });
})();

/* ---------------------------------------------------------------------------
   Recipe tabs
   The radios already drive selection; this only mirrors :checked onto the
   matching panel, because a sibling selector cannot reach from the tab strip
   into the panel container. Runs once on load so the first panel is visible.
   ------------------------------------------------------------------------ */
(function () {
  document.querySelectorAll('[data-recipes]').forEach(function (root) {
    var radios = root.querySelectorAll('[data-recipe-radio]');
    var panels = root.querySelectorAll('[data-recipe-panel]');
    if (!radios.length || !panels.length) return;

    function show() {
      var checked = root.querySelector('[data-recipe-radio]:checked');
      if (!checked) return;
      panels.forEach(function (p) {
        var on = p.getAttribute('data-recipe-panel') === checked.id;
        p.classList.toggle('is-active', on);
        if (!on) return;
        // Third-party video frames load only when their tab is opened.
        var slot = p.querySelector('[data-recipe-video]');
        if (slot && !slot.firstChild) {
          var url = slot.getAttribute('data-recipe-video') || '';
          var embed = '';
          var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
          var vm = url.match(/vimeo\.com\/(\d+)/);
          if (yt) embed = 'https://www.youtube.com/embed/' + yt[1];
          else if (vm) embed = 'https://player.vimeo.com/video/' + vm[1];
          if (embed) {
            var f = document.createElement('iframe');
            f.src = embed;
            f.loading = 'lazy';
            f.allow = 'accelerometer; encrypted-media; picture-in-picture';
            f.allowFullscreen = true;
            f.title = 'Recipe video';
            slot.appendChild(f);
          }
        }
      });
    }

    radios.forEach(function (r) { r.addEventListener('change', show); });
    show();
  });
})();

/* ---------------------------------------------------------------------------
   Purchase block
   Keeps the two price readouts and the button total honest as the customer
   switches pack size or between one-time and subscription. The form submits
   correctly without any of this — these are display updates only.
   ------------------------------------------------------------------------ */
(function () {
  var form = document.querySelector('[data-purchase]');
  if (!form) return;

  var moneyFmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/, parts.join('.'));
  }

  var subRadio = form.querySelector('[data-plan-radio][value]:not([value=""])');
  var planOptions = form.querySelectorAll('[data-plan-option]');

  // Once the customer picks a frequency themselves, stop overriding it.
  var scheduleTouched = false;

  // Plans are named by the merchant ("Deliver every 2 weeks, 15% off"), so the
  // interval is read from the label. Unparseable options are skipped rather
  // than guessed at, which just leaves the frequency as the merchant set it.
  function planWeeks(text) {
    var m = String(text).match(/(\d+)\s*(day|week|month)/i);
    if (!m) return null;
    var n = parseInt(m[1], 10);
    var unit = m[2].toLowerCase();
    if (unit === 'day') return n / 7;
    if (unit === 'month') return n * 4.345;
    return n;
  }

  // Match the delivery interval to how long the chosen pack actually lasts.
  // Three tins is ~4 weeks of matcha; shipping it every 2 weeks buries the
  // customer and they cancel. Bias toward an interval at or beyond the pack
  // duration — arriving slightly late is recoverable, arriving twice as fast
  // is not.
  function matchCadence(weeks) {
    if (!planOptions.length || scheduleTouched || !weeks || isNaN(weeks)) return;
    var best = null, bestScore = Infinity;
    Array.prototype.forEach.call(planOptions, function (o) {
      var w = planWeeks(o.dataset.planName || '');
      if (w == null) return;
      var score = w >= weeks ? (w - weeks) : (weeks - w) + 100;
      if (score < bestScore) { bestScore = score; best = o; }
    });
    if (best && !best.checked) {
      best.checked = true;
      if (subRadio) subRadio.value = best.value;
    }
  }

  function selectedVariant() {
    return form.querySelector('[data-variant-radio]:checked');
  }

  function update() {
    var v = selectedVariant();
    // A single-variant product renders no variant radios at all, so fall back
    // to the form's base price. Without this the function returned early and
    // the button kept its server-rendered one-time price while Subscribe was
    // selected — the two disagreed on screen.
    var base = v ? parseInt(v.dataset.price, 10) : parseInt(form.dataset.basePrice, 10);
    if (isNaN(base)) return;

    var onetime = form.querySelector('[data-onetime-price]');
    if (onetime) onetime.textContent = money(base);

    // Prefer Shopify's own selling-plan allocation price. Only fall back to
    // the sub_discount setting when the product has no plan yet, so the theme
    // can never quote a discount the cart will not honour.
    var alloc = v ? v.dataset.subPrice : form.dataset.subPrice;
    var subCents;
    if (alloc !== undefined && alloc !== '' && !isNaN(parseInt(alloc, 10))) {
      subCents = parseInt(alloc, 10);
    } else {
      var pct = parseFloat(form.dataset.subDiscount || '15');
      subCents = Math.round(base * (100 - pct) / 100);
    }
    var planPrice = form.querySelector('[data-plan-price]');
    if (planPrice) planPrice.textContent = money(subCents);

    // The struck-through price is the saving made visible; hide it when the
    // plan is not actually cheaper rather than showing a nonsense comparison.
    var was = form.querySelector('[data-plan-was]');
    if (was) {
      if (subCents < base) {
        was.textContent = money(base);
        was.hidden = false;
      } else {
        was.hidden = true;
      }
    }

    var chosenPlan = form.querySelector('[data-plan-radio]:checked');
    var subscribing = !!(chosenPlan && chosenPlan.value);
    var total = form.querySelector('[data-buy-total]');
    if (total) total.textContent = money(subscribing ? subCents : base);

    matchCadence(parseFloat(v ? v.dataset.weeks : form.dataset.weeks));

    var wrap = form.querySelector('[data-plan-schedule]');
    if (wrap) wrap.hidden = !subscribing;
  }

  form.addEventListener('change', function (e) {
    // Choosing a delivery frequency also chooses the plan it belongs to, and
    // marks the choice as the customer's so pack changes stop overriding it.
    if (e.target.hasAttribute && e.target.hasAttribute('data-plan-option') && subRadio) {
      scheduleTouched = true;
      subRadio.value = e.target.value;
      subRadio.checked = true;
    }
    update();
  });

  update();
})();

/* ---------- Launch countdown ----------
   The server already decided whether the drop has passed, so this only ticks
   an element that Liquid chose to render. Date.parse handles the explicit
   offset in the attribute, which is why the setting insists on one: without it
   the string would be read as local time and every timezone would see a
   different countdown. */
(function () {
  var roots = document.querySelectorAll('[data-countdown]');
  if (!roots.length) return;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  Array.prototype.forEach.call(roots, function (root) {
    var target = Date.parse(root.getAttribute('data-countdown'));
    if (isNaN(target)) return;

    var d = root.querySelector('[data-cd-d]');
    var h = root.querySelector('[data-cd-h]');
    var m = root.querySelector('[data-cd-m]');
    var sEl = root.querySelector('[data-cd-s]');
    if (!d || !h || !m || !sEl) return;

    // The glass belongs to the same section as the clock, so the countdown
    // drives it rather than a second timer that would slowly drift out of step.
    var glass = root.parentNode.querySelector('.cd-brew [data-brew-fill]');
    var gTop = glass ? parseFloat(glass.dataset.fillTop) : 0;
    var gRange = glass ? parseFloat(glass.dataset.fillBottom) - gTop : 0;

    var id = setInterval(tick, 1000);
    tick();

    function tick() {
      var left = Math.max(0, target - Date.now());
      var secs = Math.floor(left / 1000);
      // Days are not padded: "34" and "07" side by side look like a bug.
      d.textContent = Math.floor(secs / 86400);
      h.textContent = pad(Math.floor(secs / 3600) % 24);
      m.textContent = pad(Math.floor(secs / 60) % 60);
      sEl.textContent = pad(secs % 60);

      // Fills over the minute and starts again — a phin that is always part
      // way through a brew. Tying it to the whole countdown instead would move
      // the surface by a third of a pixel a day and read as broken.
      if (glass) {
        var through = (59 - (secs % 60)) / 59;
        var y = gTop + gRange - through * gRange;
        glass.style.y = y + 'px';
        glass.setAttribute('y', y);
      }

      if (left === 0) {
        clearInterval(id);
        // The page was rendered before the drop; a reload now gets the live
        // state from Liquid. Reloading here would be hostile to anyone
        // mid-signup, so it just stops.
        root.setAttribute('data-countdown-done', '');
      }
    }
  });
})();

/* ---------- Launch gate ----------
   The gate is already on screen before this runs; CSS put it there. This only
   does the two things CSS cannot: take everything behind it out of the tab
   order and off the accessibility tree, and let the shop's owner past it. */
(function () {
  var gate = document.getElementById('LaunchGate');
  if (!gate) return;

  // ?peek=1 to look at the real site, ?peek=0 to put the gate back. Stored per
  // browser, so it can never leak to a visitor, and invisible to crawlers.
  var peeking = false;
  try {
    var q = new URLSearchParams(window.location.search).get('peek');
    if (q === '1') localStorage.setItem('phin-peek', '1');
    if (q === '0') localStorage.removeItem('phin-peek');
    peeking = localStorage.getItem('phin-peek') === '1';
  } catch (e) {
    // Private mode, or storage blocked. Not a reason to open the gate.
  }

  if (peeking) {
    gate.parentNode.removeChild(gate);
    document.body.classList.remove('is-gated');
    return;
  }

  // CSS stops the pointer, but the nav is still tabbable and still announced
  // behind an overlay unless it is inert. Unsupported in older Safari, where
  // the visual cover is still doing its job.
  Array.prototype.forEach.call(document.body.children, function (el) {
    if (el === gate) return;
    if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
    el.setAttribute('inert', '');
  });

  gate.focus({ preventScroll: true });
})();

